"use client";

import { c as _c } from "react/compiler-runtime";
import * as React from "react";
import { cn } from "@/lib/utils";
import { BlurFade } from "./blur-fade";
interface PageHeaderProps {
  eyebrow?: React.ReactNode;
  title: React.ReactNode;
  description?: React.ReactNode;
  actions?: React.ReactNode;
  className?: string;
}
export function PageHeader(t0) {
  const $ = _c(18);
  const {
    eyebrow,
    title,
    description,
    actions,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== eyebrow) {
    t2 = eyebrow && <BlurFade delay={0.1} inView={true}><p className="label-uppercase mb-1.5">{eyebrow}</p></BlurFade>;
    $[2] = eyebrow;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== title) {
    t3 = <BlurFade delay={0.15} inView={true}><h1 className="text-[1.875rem] font-black leading-none text-[#09090B] tracking-[-0.03em]">{title}</h1></BlurFade>;
    $[4] = title;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== description) {
    t4 = description && <BlurFade delay={0.25} inView={true}><p className="mt-2 text-[13px] leading-relaxed text-[#71717A]">{description}</p></BlurFade>;
    $[6] = description;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t2 || $[9] !== t3 || $[10] !== t4) {
    t5 = <div className="min-w-0">{t2}{t3}{t4}</div>;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== actions) {
    t6 = actions && <BlurFade delay={0.3} inView={true}><div className="shrink-0">{actions}</div></BlurFade>;
    $[12] = actions;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t1 || $[15] !== t5 || $[16] !== t6) {
    t7 = <div className={t1}>{t5}{t6}</div>;
    $[14] = t1;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
}
interface DashboardSectionProps extends Omit<React.HTMLAttributes<HTMLElement>, "title"> {
  title?: React.ReactNode;
  description?: React.ReactNode;
  actions?: React.ReactNode;
}
export function DashboardSection(t0) {
  const $ = _c(18);
  let actions;
  let children;
  let className;
  let description;
  let props;
  let title;
  if ($[0] !== t0) {
    ({
      title,
      description,
      actions,
      className,
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = actions;
    $[2] = children;
    $[3] = className;
    $[4] = description;
    $[5] = props;
    $[6] = title;
  } else {
    actions = $[1];
    children = $[2];
    className = $[3];
    description = $[4];
    props = $[5];
    title = $[6];
  }
  let t1;
  if ($[7] !== className) {
    t1 = cn("space-y-4", className);
    $[7] = className;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  let t2;
  if ($[9] !== actions || $[10] !== description || $[11] !== title) {
    t2 = (title || description || actions) && <div className="flex items-end justify-between gap-3"><div className="min-w-0">{title && <h2 className="text-[15px] font-bold text-[#09090B] tracking-[-0.015em]">{title}</h2>}{description && <p className="mt-1 text-[12px] leading-5 text-[#71717A]">{description}</p>}</div>{actions && <div className="shrink-0">{actions}</div>}</div>;
    $[9] = actions;
    $[10] = description;
    $[11] = title;
    $[12] = t2;
  } else {
    t2 = $[12];
  }
  let t3;
  if ($[13] !== children || $[14] !== props || $[15] !== t1 || $[16] !== t2) {
    t3 = <section className={t1} {...props}>{t2}{children}</section>;
    $[13] = children;
    $[14] = props;
    $[15] = t1;
    $[16] = t2;
    $[17] = t3;
  } else {
    t3 = $[17];
  }
  return t3;
}